import { render, staticRenderFns } from "./EmergencyContactList.vue?vue&type=template&id=30fa2e6a&scoped=true"
import script from "./EmergencyContactList.vue?vue&type=script&lang=js"
export * from "./EmergencyContactList.vue?vue&type=script&lang=js"
import style0 from "./EmergencyContactList.vue?vue&type=style&index=0&id=30fa2e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fa2e6a",
  null
  
)

export default component.exports